import {Utils} from '../../app.base';
import {MsgBox, Routes, Vue} from '../../app.vues';

import SwbSettltProofInvoiceVoucherInfo from './SettltProofInvoiceVoucherInfo';

Vue.regist(SwbSettltProofInvoiceVoucherInfo);

// 结算单发票信息
export function showSettleProofInvoiceVoucherInfoDlg(params, callback) {
    let settleProofId = params.settleProofId || null;
    let theDlg = Vue.$showDialog({
        title: '发票信息',
        width: -400,
        height: 800,
        cancelVisible: true,
        cancelText: '关闭',
        okVisible: false,
        template: '<swb-settle-proof-invoice-voucher-info :settleProofId="settleProofId" ref="swb_settle_proof_invoice_voucher_info"></swb-settle-proof-invoice-voucher-info>',
        data: {
            settleProofId: settleProofId
        },
        okClicked: function () {
            let result = this.$refs.swb_settle_proof_invoice_voucher_info.getDlgResult() || {};
            //
            return false;
        },
        cancelClicked: function () {
            let result = this.$refs.swb_settle_proof_invoice_voucher_info.getDlgResult() || {};
            if (result.type === 'info') {
                let refresh = result.data || false;
                callback(refresh);
            } else {
                MsgBox.warning(result.message);
            }
        }
    });
}

import SwbInvoiceVoucherListForSelect from './InvoiceVoucherListForSelect';

Vue.regist(SwbInvoiceVoucherListForSelect);

export function showInvoiceVoucherListForSelect(params, callback) {
    let settleProofId = params.settleProofId || null;
    let buyerRealComId = params.buyerRealComId || null;
    let buyerRealComCode = params.buyerRealComCode || null;
    let invoiceType = params.invoiceType;
    let theDlg = Vue.$showDialog({
        title: '发票列表-选择',
        width: -400,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-invoice-voucher-list-select :invoiceType="invoiceType" :settleProofId="settleProofId" :buyerRealComId="buyerRealComId" :buyerRealComCode="buyerRealComCode" ref="swb_invoice_voucher_list_select"></swb-invoice-voucher-list-select>',
        data: {
            buyerRealComId: buyerRealComId,
            buyerRealComCode: buyerRealComCode,
            settleProofId: settleProofId,
            invoiceType: invoiceType
        },
        okClicked: function () {
            let result = this.$refs.swb_invoice_voucher_list_select.getDlgResult() || {};
            if (result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbInvoiceVoucherSave from './InvoiceVoucherSave';

Vue.regist(SwbInvoiceVoucherSave);

/** 登记发票 */
export function createInvoiceVoucher(params, callback) {
    let title = Utils.isNoB(params['title']) ? '登记发票' : params['title'];
    let settleProofId = params['settleProofId'] || null;
    let invoiceAmount = params['invoiceAmount'] || null;
    let invoiceType = params['invoiceType'];
    let theDlg = Vue.$showDialog({
        title: title,
        width: -460,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-invoice-voucher-save :invoiceType="invoiceType" :settleProofId="settleProofId" :invoiceAmount="invoiceAmount" ref="swb_invoice_voucher_save"></swb-invoice-voucher-save>',
        data: {
            settleProofId: settleProofId,
            invoiceAmount: invoiceAmount,
            invoiceType: invoiceType
        },
        okClicked: function () {
            let result = this.$refs.swb_invoice_voucher_save.getDlgResult() || {};
            if (result.type == 'info') {
                callback(result, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbInvoiceSubjectForSelect from './InvoiceSubjectForSelect';

Vue.regist(SwbInvoiceSubjectForSelect);

/** 开票信息-选择 */
export function selectInvoiceSubjectDlg(params, callback) {
    let showAddFlag = params['showAddFlag'] || null;
    let buyerRealComId = params['buyerRealComId'] || null;
    let buyerRealComCode = params['buyerRealComCode'] || null;
    let invoiceType = params['invoiceType'];
    //
    let theDlg = Vue.$showDialog({
        title: '开票信息-选择',
        width: -460,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-invoice-subject-list-for-select :showAddFlag="showAddFlag" :buyerRealComId="buyerRealComId" :buyerRealComCode="buyerRealComCode" :invoiceType="invoiceType" ref="swb_invoice_subject_list_for_select"></swb-invoice-subject-list-for-select>',
        data: {
            showAddFlag: showAddFlag,
            buyerRealComId: buyerRealComId,
            buyerRealComCode: buyerRealComCode,
            invoiceType: invoiceType
        },
        okClicked: function () {
            let result = this.$refs.swb_invoice_subject_list_for_select.getDlgResult() || {};
            if (result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/invoiceVoucher/selectDlg.js
// module id = 194
// module chunks = 0